module.exports = __webpack_public_path__ + "static/img/son1.492352a8.png";